import { COMPONENT_NAME } from '@core/components/grid-data/grid-helper';
import { ActivityLogType } from '@core/configs/activity-log-type.enum';
import { FieldActivityType } from '@core/models/enums';

export const activityLogFunctionalTrainingConfig = {
  width: '100%',
  height: '100%',
  min: 1,
  interval: 1,
  max: 24,
  timeInterval: 15,
  itemHeight: 'auto',
  rows: 3,
  borderColor: '#FFFFFF',
  isHiddenBorder: false,
  isHiddenHeader: true,
  segmentNum: 6,
  isAsc: true,
  showOdd: true,
  fixedActivityTypeRowGroups: [
    [FieldActivityType.MEDICINE],
    [FieldActivityType.URINATION, FieldActivityType.DEFECATION]
  ], // should have to make icon has the fixed location
  type: ActivityLogType.LogCurrent,
  marginToTime: 45
};

export const functionalTrainingGridConfig = {
  isLockPage: false,
  currentPage: 1,
  pageSize: 10,
  totalPage: 1,
  intervalTime: 30000,
  defaultConfig: {
    isSortByRoom: true,
    isSortByName: false,
    timeRangeSelected: 6,
    marginToTimeSelected: 30,
    unitSelected: [],
    groupSelected: []
  },
  data: [],
  header: [
    {
      width: "1.5vw",
      fixedSize: true,
      items: [{ title: '' }],
      field: 'index',
      component: COMPONENT_NAME.LeaveComponent,
      config: { isDarkMode: true, width: '100%', height: '100%', cellClass: "default" }
    },
    {
      width: "7%",
      items: [{ title: '居室名' }],
      field: 'room_name',
      headerName: '居室名',
      component: COMPONENT_NAME.DynamicLabelComponent,
      config: { isDarkMode: true, width: '100%', height: '100%', fontSize: "1vw", cellClass: "scrolling-text", whitespace: 'normal' },
      visible: false,
    },
    {
      width: "12vw",
      items: [{ title: '名前' }],
      field: 'user',
      headerName: '名前',
      fixedSize: true,
      component: COMPONENT_NAME.UserInfoComponent,
      config: { isDarkMode: true, cellClass: "scrolling-text" }
    },
    {
      width: "10%",
      items: [{ title: '体温', textAlign: 'center', padding: '0 0 0 0.4vw' }, { title: '脈拍', textAlign: 'center', padding: '0 0.4vw 0 0' }],
      isSplitCell: true,
      subheader: [{
        width: "100%",
        items: [{ width: "50%", title: '血圧', textAlign: 'center', padding: '0 0 0 0.4vw' }, { width: "50%", title: 'SPO2', textAlign: 'center', padding: '0 0.4vw 0 0' }],
      }],
      field: 'vital',
      headerName: 'バイタル',
      component: COMPONENT_NAME.VitalComponent,
      config: { isDarkMode: true, cellClass: "scrolling-text" }
    },
    {
      width: "5%",
      items: [{ title: '食事' }],
      field: 'meal',
      headerName: '食事',
      component: COMPONENT_NAME.MealComponent,
      config: { isDarkMode: true, cellClass: "scrolling-text" }
    },
    {
      width: "5%",
      field: 'meal_moisture',
      colname: 'meal_moisture',
      items: [{ title: '水分' }],
      headerName: '食事水分',
      component: COMPONENT_NAME.MealMoistureComponent,
      config: { isDarkMode: true, cellClass: "scrolling-text" },
      visible: true
    },
    {
      width: "5%",
      items: [{ title: '歯磨き' }],
      field: 'oral',
      headerName: '歯磨き',
      component: COMPONENT_NAME.YesNoIndicatorComponent,
      config: { isDarkMode: true, cellClass: "dynamic-label" }
    },
    {
      width: "5%",
      items: [{ title: 'おやつ' }],
      field: 'snack',
      hasSubHeader: true,
      headerName: 'おやつ',
      component: COMPONENT_NAME.BatsuMaruComponent,
      config: { isDarkMode: true, cellClass: "scrolling-text" }
    },
    {
      width: "5%",
      items: [{ title: '水分' }],
      subheader: [{
        width: "100%",
        items: [{ title: '合計' }],
      }],
      field: 'moisture',
      headerName: '水分合計',
      component: COMPONENT_NAME.DynamicLabelComponent,
      config: { isDarkMode: true, width: '100%', height: '100%', cellClass: "scrolling-text" }
    },
    {
      width: "5%",
      items: [{ title: '入浴' }],
      field: 'bathe',
      headerName: '入浴',
      component: COMPONENT_NAME.AttentionComponent,
      config: { isDarkMode: true, cellClass: "dynamic-label", activeCancelMark: true }
    },
    {
      width: "4%",
      items: [{ title: '機能' }],
      field: 'function_training',
      headerName: '機能訓練',
      component: COMPONENT_NAME.TrainingComponent,
      config: { cellClass: "dynamic-label", activeCancelMark: true },
      subheader: [{
        width: "100%",
        items: [{ title: '訓練' }],
      }]
    },
    {
      width: "20%",
      items: [{ title: '服薬　排泄' }],
      headeRepeat: 1,
      subheader: [{
        width: "100%",
        items: [{ title: '服薬　排泄', useComponent: true, componentSubHeader: COMPONENT_NAME.FieldActivityHeaderComponent, configSubHeader: activityLogFunctionalTrainingConfig }],
      }],
      field: 'medicine_list',
      headerName: '服薬　排泄',
      component: COMPONENT_NAME.FieldActivityLogComponent,
      config: activityLogFunctionalTrainingConfig,
    },
    {
      width: "auto",
      items: [{ title: '申し送り' }],
      field: 'attention_list',
      headerName: '申し送り',
      component: COMPONENT_NAME.TextMarqueeComponent,
      config: { isDarkMode: true, width: '100%', height: '100%', highlight: true, cellClass: "scrolling-text" }
    },
  ]
};

export const functionalTrainingPositionDialog = [
  { field: 'index' },
  { field: 'room_name' },
  { field: 'user' },
  { field: 'vital' },
  { field: 'meal' },
  { field: 'meal_moisture' },
  { field: 'oral' },
  { field: 'snack' },
  { field: 'snack_moisture' },
  { field: 'moisture' },
  { field: 'bathe' },
  { field: 'function_training' },
  { field: 'medicine_list' },
  { field: 'attention_list' },
];
